import React, { createContext, useState, useEffect, useContext } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const apiUrl = process.env.REACT_APP_MONGO_URL;

  useEffect(() => {
    fetch(`${apiUrl}/api/auth`)
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
      })
      .catch((error) => {
        console.error("Hata:", error);
      });
  }, [apiUrl]);

  const addUser = (newUser) => {
    fetch(`${apiUrl}/api/auth/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newUser),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers((prev) => [...prev, data]);
      })
      .catch((error) => {
        console.error("Ekleme hatası:", error);
      });
  };

  const deleteUser = (id) => {
    // Önce UI'de listeyi filtrele
    setUsers((prev) => prev.filter((user) => user._id !== id));
  
    // API isteği gönder
    fetch(`${apiUrl}/api/auth/${id}`, {
      method: "DELETE",
    })
      .catch((error) => {
        console.error("Silme hatası:", error);
      });
  };  

  return (
    <UserContext.Provider value={{ users, deleteUser, addUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUsers = () => useContext(UserContext);
